import React, { useRef, useEffect, useMemo, useState } from 'react';
import { useField } from '@unform/core';
import PropTypes from 'prop-types';
import JoditEditor from 'jodit-react';

import { Container, ErrorMessage } from './styles';

const RichTextArea = ({ name, height, errorField, disabled }) => {
  const editor = useRef(null);
  const { fieldName, registerField, defaultValue = '', error } = useField(name);
  const [content, setContent] = useState(defaultValue);

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => content,
      setValue: (_, value) => setContent(value),
      clearValue: () => setContent(''),
    });
  }, [fieldName, registerField, content]);

  const config = useMemo(() => {
    return {
      readonly: disabled,
      placeholder: '',
      height: height,
    };
  }, [height, disabled]);

  return (
    <Container className="richTextContainer" error={error} disabled={disabled}>
      <JoditEditor
        ref={editor}
        value={content}
        config={config}
        onBlur={newContent => setContent(newContent)}
      />
      <ErrorMessage>{error || errorField}</ErrorMessage>
    </Container>
  );
};

RichTextArea.propTypes = {
  name: PropTypes.string.isRequired,
  height: PropTypes.string,
  errorField: PropTypes.string,
};

export default RichTextArea;
